import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnInit
} from '@angular/core';
import {BaseFieldComponent} from '../base-field.component';

@Component({
    selector: 'app-form-group',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="form-group" [style.marginBottom.px]="marginBottom" [class.form-group-error]="hasError">
            <app-form-label *ngIf="label" [required]="required">{{label}}</app-form-label>
            <ng-content></ng-content>
            <app-form-error-message *ngIf="fbControl && showErrorMessage" [fbControl]="fbControl"></app-form-error-message>
        </div>`,
    styles: [`
        :host {
            display: block;
        }
    `]
})

export class FormGroupComponent extends BaseFieldComponent implements OnInit {

    @Input() label: string;
    @Input() required = false;
    /**
     * В некоторых случаях нужно отображать только кастомное сообщение об ошибке вручную,
     * поэтому это поле отключает показ ошибки, находящейся в fbControl.errors
     * @type {boolean}
     */
    @Input() showErrorMessage = true;

    public hasError = false;

    constructor(
        private cd: ChangeDetectorRef
    ) {
        super();
    }


    ngOnInit() {
        super.ngOnInit();
        if (!this.fbControl) {
            return;
        }

        this.hasError = Boolean(this.fbControl.errors);

        this.subs.push(
            this.fbControl.statusChanges.subscribe(() => {
                const hasError = Boolean(this.fbControl.errors);

                if (this.hasError === hasError) {
                    return;
                }

                this.hasError = hasError;
                this.cd.detectChanges();
            })
        );


    }
}
